import getVideoTestimonials from './getVideoTestimonials'

const videoTestimonials = {
  getVideoTestimonials
}

export default videoTestimonials
